// .\client\src\components\Admin\AuditLog.jsAuditLog.js
import React, { useState } from "react";
import { useAppContext } from "../../context/appContext";
import { useNavigate } from "react-router-dom";
import { Input, Display, Display1 } from "../../components/workspace";
import ConfirmBox from "../ConfirmBox";
import { isEqual } from 'lodash';

function AuditLog() {
	const {
		auditLog,
		lists,
		employees,
		indices,
		isLoading,
		handleChange,
		createRecord,
		getArrayRecord,
		saveRecord,
		loadMainRecords,
		showConfirmBox,
		toggleConfirmBox,
	} = useAppContext();

	const [selectedRow, setSelectedRow] = useState(null);

	const now = new Date();
	const initialState = {
		search: "",
		jobType: "default",
		jobStatus: "default",
		beginTime: "",
		endTime: now.toLocaleString()
	}

	const [filters, setFilters] = useState(initialState);

	const navigate = useNavigate();

	const index = indices.auditLogIndex;

	const dateFormat = {
		month: "short",
		day: "numeric",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	};
	const getDate = (date) => {
		const dateObj = new Date(date);
		return dateObj.toLocaleString("en-US", dateFormat);
	};
	const getUser = (userId) => employees?.filter((emp) => emp.id === userId)[0]?.full_name;
	const getJobNumber = (jobId) => {
		return lists?.allJobs.filter((job) => job.id === jobId)[0]?.job_number;
	};
	const getTable = (path) => path?.split("/")[0];
	const getAction = (path) => path?.split("/")[1];

	const refreshLog = async () => {
		filterResults(filters)
		await getArrayRecord(`/defaults/get-audit-log`, "auditLog");
	};

	const resetFilters = () => {
		setFilters(initialState);
		setSelectedRow(null);
	};

	const filterResults = (newFilters) => {
		if (!auditLog) {
			return;
		}
		let filtered = auditLog;
		// filter results
		filtered = filtered?.filter((logObject) => {
			const { path, created_at, core_job_id, user_roles_id, new_data, old_data } = logObject;
			// build lowercase variables for an easy case agnostic search
			const procFilter = newFilters.search?.toLowerCase();
			const pathSearch = path?.toLowerCase();
			const userSearch = user_roles_id?.toLowerCase();
			const newDataSearch = JSON.stringify(new_data)?.toLowerCase();
			const oldDataSearch = JSON.stringify(old_data)?.toLowerCase();
			const createdDate = new Date(created_at)
			const beginDate = newFilters.beginTime ? new Date(newFilters.beginTime) : new Date(0)
			const endDate = new Date(newFilters.endTime)
			let match = false;

			// check the search input text for matches
			if (
				pathSearch?.includes(procFilter) ||
				getJobNumber(core_job_id)?.includes(procFilter) ||
				userSearch?.includes(procFilter) ||
				newDataSearch?.includes(procFilter) ||
				oldDataSearch?.includes(procFilter) &&
				beginDate?.getTime() < createdDate.getTime() &&
				endDate.getTime() >= createdDate.getTime()
			) {
				match = true;
			}

			return match;
		});
		return filtered;
	};

	const handleInput = (e, number) => {
		const name = e.target.name;
		const value = number ? Number(e.target.value) : e.target.value;

		setFilters({
			...filters,
			[name]: value,
		});
		filterResults({
			...filters,
			[name]: value,
		});
	};

	const loadJob = () => {
		loadMainRecords(auditLog[index].core_job_id);
		navigate("../job-summary");
	};

	const confirmUndo = (e) => {
		e.preventDefault();
		toggleConfirmBox({ confirmed: false });
	};

	const undoChanges = () => {
		let path = auditLog[index].path;
		const tableObject = auditLog[index].old_data;
		const tableName = getTable(path);
		if (getAction(path) === "update") {
			saveRecord(path, tableObject, tableName);
		}
		if (getAction(path) === "delete") {
			path = `${tableName}/create`;
			createRecord(path, tableObject, tableName);
		}
		loadMainRecords(auditLog[index].core_job_id);
	};

	const selectRow = async (e, jobId, index) => {
		if (
			e.target.parentNode.className === "selected" ||
			e.target.parentNode.parentNode.className === "selected"
		) {
			// loadMainRecords(jobId);
			// navigate("../job-summary");
		}
		setSelectedRow(jobId);
		// set appointmentsIndex
		handleChange({
			baseObject: { ...indices },
			name: "indices.auditLogIndex",
			value: index,
		});
	};

	const getDifferences = (oldData, newData) => {
	  if (!oldData || !newData) return { oldDataStr: '', newDataStr: '' };

	  const allKeys = new Set([...Object.keys(oldData), ...Object.keys(newData)]);
	  const oldDataDiffs = {};
	  const newDataDiffs = {};

	  allKeys.forEach(key => {
	    if (!isEqual(oldData[key], newData[key])) {
	      oldDataDiffs[key] = oldData[key];
	      newDataDiffs[key] = newData[key];
	    }
	  });

	  const format = obj => JSON.stringify(obj, null, 2).slice(1, -1).trim();
	  return { oldDataStr: format(oldDataDiffs), newDataStr: format(newDataDiffs) };
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	return (
		<>
			<form className="form" onSubmit={handleSubmit}>
				<h3>Recent Database Changes</h3>
				<div className="form-center">
					{/* Search bar and clear filters button */}
					<div className="whole flex-parent">
						<button className="btn" type="button" onClick={refreshLog} disabled={isLoading}>
							Refresh Log
						</button>
						<button className="btn red" type="button" onClick={resetFilters} disabled={isLoading}>
							Clear All
						</button>
						<div className="one-half">
							<Input
								type="text"
								name="search"
								value={filters.search}
								handleChange={(e) => handleInput(e)}
							/>
						</div>
						<div className="one-third flex-parent">
							<Input
								type="datetime-local"
								name="beginTime"
								label="Beginning of Search Window"
								value={filters.beginTime}
								handleChange={(e) => handleInput(e)}
							/>
							<Input
								type="datetime-local"
								name="endTime"
								label="End of Search Window"
								value={filters.endTime}
								handleChange={(e) => handleInput(e)}
							/>
						</div>
					</div>
					{/* Display selected record info */}
					{selectedRow && (
						<div className="whole flex-parent">
							<div className="one-fourth">
								<Display name="Updated At" value={getDate(auditLog[index]?.created_at)} />
								<Display name="Job Number" value={getJobNumber(auditLog[index]?.core_job_id)} />
								<Display name="Request Path" value={auditLog[index]?.path} />
								<div className="whole flex-parent">
									<button className="btn" type="button" onClick={loadJob} disabled={isLoading}>
										Load Job
									</button>
									<button
										className="btn red"
										type="button"
										onClick={confirmUndo}
										disabled={isLoading}
									>
										Undo Changes
									</button>
								</div>
							</div>
							<div className="one-fourth">
								<Display name="Updated By" value={getUser(auditLog[index]?.user_id)} />
								<Display name="Ip Address" value={auditLog[index]?.ip_address} />
								<Display name="User Agent" value={auditLog[index]?.user_agent} />
							</div>
							<div className="one-fourth">
								<Display1
									name="New Data"
									value={
										getDifferences(auditLog[index]?.old_data, auditLog[index]?.new_data).newDataStr
									}
									style={{ color: "green", overflow: "scroll", maxHeight: "12rem" }}
								/>
							</div>
							<div className="one-fourth">
								<Display1
									name="Old Data"
									value={
										getDifferences(auditLog[index]?.old_data, auditLog[index]?.new_data).oldDataStr
									}
									style={{ color: "red", overflow: "scroll", maxHeight: "12rem" }}
								/>
							</div>
						</div>
					)}
					{/* ------- Audit Table -------- */}
					<div className="table whole admin-log">
						<table>
							<thead>
								<tr>
									<th style={{ width: 180 }}>Time</th>
									<th style={{ width: 100 }}>Job Number</th>
									<th style={{ width: 210 }}>Path</th>
									<th style={{ width: 124 }}>User</th>
									<th style={{ width: 120 }}>Ip Address</th>
									<th>New Data</th>
									<th>Old Data</th>
								</tr>
							</thead>
							<tbody>
								{/* Loop through each job to build row data */}
								{filterResults(filters)?.map((record, index) => {
									const { oldDataStr, newDataStr } = getDifferences(record.old_data, record.new_data);
									return index < 240 ? (
										<tr
											key={record.id}
											className={selectedRow === record.id ? "selected" : ""}
											onClick={(e) => selectRow(e, record.id, index)}
										>
											<td>{getDate(record.created_at)}</td>
											<td>{getJobNumber(record.core_job_id)}</td>
											<td>{record.path}</td>
											<td>{getUser(record.user_id)}</td>
											<td>{record.ip_address}</td>
											<td>
												<div className="json-cell" style={{ color: "green" }}>
													{newDataStr}
												</div>
											</td>
											<td>
												<div className="json-cell" style={{ color: "red" }}>
													{oldDataStr}
												</div>
											</td>
										</tr>
									) : (
										""
									);
								})}
							</tbody>
						</table>
					</div>
				</div>
			</form>
			{/* ----- Confirmation Box ------ */}
			<div className={showConfirmBox ? "show-modal modal-container" : "modal-container"}>
				<div className="group">
					<ConfirmBox
						confirmedFunction={undoChanges}
						message={`Are you sure you want to undo the previous ${getAction(
							auditLog[index]?.path
						)} to ${getTable(auditLog[index]?.path)} for ${getJobNumber(
							auditLog[index]?.core_job_id
						)}?`}
					/>
				</div>
			</div>
		</>
	);
}
export default AuditLog;
